import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AutocompleteInput from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.autocompleteInput,
  };
}

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AutocompleteInput));



// WEBPACK FOOTER //
// ./src/components/AutocompleteInput/container/index.js